(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["sale-countdown"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rite-countdown')) {
    class RiteCountdown extends HTMLElement {
      connectedCallback() {
        this.end = new Date(this.dataset.end).getTime();
        if (isNaN(this.end)) return;
        this.el = {
          d: this.querySelector('[data-d]'),
          h: this.querySelector('[data-h]'),
          m: this.querySelector('[data-m]'),
          s: this.querySelector('[data-s]')
        };
        this.tick();
        this.timer = setInterval(() => this.tick(), 1000);
      }
      disconnectedCallback() { clearInterval(this.timer); }
      tick() {
        const diff = this.end - Date.now();
        if (diff <= 0) {
          clearInterval(this.timer);
          const wrap = this.closest('.rite-countdown');
          if (this.dataset.hide === 'true') { wrap.style.display = 'none'; return; }
          this.innerHTML = '<span class="rite-countdown__expired"></span>';
          this.firstChild.textContent = this.dataset.expired;
          return;
        }
        const p = (n) => String(n).padStart(2, '0');
        const t = Math.floor(diff / 1000);
        this.el.d.textContent = p(Math.floor(t / 86400));
        this.el.h.textContent = p(Math.floor((t % 86400) / 3600));
        this.el.m.textContent = p(Math.floor((t % 3600) / 60));
        this.el.s.textContent = p(t % 60);
      }
    }
    customElements.define('rite-countdown', RiteCountdown);
  }
  } catch(e) { console.error(e); }
})();

})();
